import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('politique-confidentialite.title')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        innerHTML: _ctx.staticTranslations.part1
      }, null, 8, _hoisted_4),
      _createElementVNode("div", {
        innerHTML: _ctx.staticTranslations.part2
      }, null, 8, _hoisted_5),
      _createElementVNode("div", {
        innerHTML: _ctx.staticTranslations.part3
      }, null, 8, _hoisted_6),
      _createElementVNode("div", {
        innerHTML: _ctx.staticTranslations.part4
      }, null, 8, _hoisted_7),
      _createElementVNode("div", {
        innerHTML: _ctx.staticTranslations.part5
      }, null, 8, _hoisted_8),
      _createElementVNode("div", {
        innerHTML: _ctx.staticTranslations.part6
      }, null, 8, _hoisted_9),
      _createElementVNode("div", {
        innerHTML: _ctx.staticTranslations.part7
      }, null, 8, _hoisted_10)
    ])
  ]))
}